import { useCallback } from 'react'

import { get } from '@/services/units/get'

export const useUnitGet = () => {
  const unitGet = useCallback(async (unitId: string) => {
    try {
      const response = await get({
        id: unitId
      })

      return response?.content || ''
    } catch (error) {
      console.error('Error get operator:', error)
      return error
    }
  }, [])

  return { unitGet }
}
